import { registerPlugin } from '@capacitor/core';
const CapacitorPrint = registerPlugin('CapacitorPrint', {
    web: () => import('./web').then(m => new m.CapacitorPrintWeb()),
});
export * from './definitions';
export { CapacitorPrint };
//# sourceMappingURL=index.js.map